<template>
  <div id="app">
    <div class="menu-mobile">
      <h1>Maison de la marchande</h1>
      <a @click="menuClosed = !menuClosed" :class="{'opened': !menuClosed}">
        <span></span>
        <span></span>
        <span></span>
      </a>
      <a class="lang-mobile" @click="switchLocale($i18n.locale)"><span v-if="$i18n.locale === 'fr'">EN</span><span v-else>FR</span></a>
    </div>
    <div id="nav" ref="nav" :class="{'opened': !menuClosed}">
      <router-link to="/">{{$t('nav.home')}}</router-link>
      <router-link to="/rooms">{{$t('nav.rooms')}}</router-link>
      <!-- <router-link to="/rates">{{$t('nav.rates')}}</router-link> -->
      <!-- <router-link to="/bookings">{{$t('nav.bookings')}}</router-link> -->
      <router-link to="/discover">{{$t('nav.discover')}}</router-link>
      <!-- <router-link to="/compostelle">{{$t('nav.compostelle')}}</router-link> -->
      <router-link to="/terms">{{$t('nav.terms')}}</router-link>
      <router-link to="/reviews">{{$t('nav.reviews')}}</router-link>
      <router-link to="/contact">{{$t('nav.contact')}}</router-link>

      <!-- <router-link to="/test/guestsbook">{{$t('nav.guests_book')}}</router-link> -->
      <!-- <a class="lang" v-if="$i18n.locale === 'en'" @click="$i18n.locale = 'fr'">FR</a>
      <a class="lang" v-else @click="$i18n.locale = 'en'">EN</a>-->
      <a class="lang" @click="switchLocale($i18n.locale)"><span v-if="$i18n.locale === 'fr'">English</span><span v-else>Français</span></a>
    </div>
    <!-- <div class="new-year" v-if="showBanner">
      <h2> {{ $t('home.message') }} </h2>
      <a class="close" @click="hideBanner">
        &times;
      </a>
    </div> -->
    <div id="body">
      <transition name='fade'>
        <router-view/>
      </transition>
    </div>
    <div id="footer">
      <div class="links">
        <router-link to="/">{{$t('nav.home')}}</router-link>
        <router-link to="/rooms">{{$t('nav.rooms')}}</router-link>
        <!-- <router-link to="/rates">{{$t('nav.rates')}}</router-link> -->
        <!-- <router-link to="/test/bookings">{{$t('nav.bookings')}}</router-link> -->
        <router-link to="/discover">{{$t('nav.discover')}}</router-link>
        <!-- <router-link to="/compostelle">{{$t('nav.compostelle')}}</router-link> -->
        <router-link to="/terms">{{$t('nav.terms')}}</router-link>
        <router-link to="/reviews">{{$t('nav.reviews')}}</router-link>
        <router-link to="/contact">{{$t('nav.contact')}}</router-link>
         <!-- <router-link to="/test/guestsbook">{{$t('nav.guests_book')}}</router-link> -->
      </div>
      <p class="bold">Maison de la Marchande</p>
      <p>31 Chemin de la marchande,<br>46000 Cahors</p>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  mounted () {
    if (window.innerWidth < 500) {
      this.menuClosed = true
    }
    document.addEventListener('resize', () => {
      if (window.innerWidth < 500) {
        this.menuClosed = true
      }
    })
    document.addEventListener('scroll', () => {
      if (window.scrollY  > 10) {
        this.menuClosed = true
      }
      if (window.scrollY > 50) {
        document.getElementById('nav').classList.add('scrolled')
      } else {
        document.getElementById('nav').classList.remove('scrolled')
      }
    })
    /*eslint-disable*/
    console.log('rooms', this.$route)
    // if (this.$route)
    /*eslint-enable*/
  },
  data () {
    return  {
      menuClosed: false
    }
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    },
    hideBanner () {
      this.$store.commit('app/hideBanner')
    },
    switchLocale(locale) {
      if (locale === 'fr') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.$store.commit('app/setLocale', this.$i18n.locale)
    }
  },
  computed: {
     ...mapState({
      showBanner: state => state.app.showBanner
    }),
  },
  watch: {
    '$route' () {
      this.menuClosed = true
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
@import './index.scss';
#app {
  font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  overflow-x: hidden;
}
#body {
  min-height: calc(100vh - 50px);
  height: 100%;
}
.menu-mobile {
  z-index: 99;
  display: none;
  position: relative;
  span {
    display: block;
    width: 33px;
    height: 3px;
    margin-bottom: 5px;
    position: relative;
    background: #a7a7a7;
    border-radius: 3px;
    z-index: 1;
    transform-origin: 0px 0px;
    transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
                opacity 0.55s ease;
  }

  span:first-child {
    transform-origin: 0% 0%;
  }

  span:nth-last-child(2) {
    transform-origin: 0% 100%;
  }

  .opened {
    span
    {
      transform: rotate(45deg) translate(-6px, -15px);
      background: black;
    }
    span:nth-last-child(3) {
      opacity: 0;
      transform: rotate(0deg) scale(0.2, 0.2);
    }

    span:nth-last-child(2) {
      transform: rotate(-45deg) translate(-7px, 15px);
    }

  }
  .lang-mobile {
    span {
      background: none;
      margin: 0;
      transform: none;
      width: auto;
      height: auto;
    }
    font-weight: bold;
    color: #7599bd;
    font-size: 18px;
    position: absolute;
    right: 40px;
    top: 0px;
  }
}


.new-year {
  margin-top: 50px;
  position: relative;
  height: 80px;
  background-color: white;
  color: $dark-blue;
  border-bottom: 1px solid $light-blue;
  border-top: 1px solid $light-blue;
  h2 {
    line-height: 100%;
  }
  .close {
    font-size: 25px;
    font-weight: bold;
    position: absolute;
    right: 6px;
    top: 6px;
    cursor: pointer;
  }
}

#nav {
  display: flex;
  top: 0px;
  flex-direction: row;
  position: fixed;
  height: 50px;
  width: 100vw;
  background-color: white;
  transition: transform 0.5s ease;
  z-index: 98;
  &.scrolled {
    box-shadow: 0 4px 9px 0 rgba(0,0,0,0.1);
  }
  img {
    width: auto;
    height: 50px;
  }
  a {
    display: block;
    font-weight: bold;
    color: #7599bd;
    text-decoration: none;
    cursor: pointer;
    line-height: 50px;
    margin: 0 10px;
    text-align: center;
    font-size: 18px;
    user-select: none;
    &.router-link-exact-active {
      color: #34495E;
    }
    &:hover {
      color: #34495E;
    }
  }
  a.lang {
    position: absolute;
    right: 20px;
    top: 0px;
  }
  &.hidden {
    opacity: 0;
    pointer-events: none;
    // transform: translate(0, -50px);
  }
}

@media (max-width: 690px) {
  #nav {
    flex-direction: column;
    height: 250px;
    z-index: 98;
    transform: translate(0px, -250px);
    a {
      height: 40px;
      line-height: 40px;
    }
    &.opened {
      transform: translate(0px, 40px);
      box-shadow: 0 4px 9px 0 rgba(0,0,0,0.1);
    }
    .lang {
      display: none;
    }
  }
  .menu-mobile {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    z-index: 99;
    box-shadow: 0 4px 9px 0 rgba(0,0,0,0.1);
    width: 100%;
    background-color: white;
    transform: translate(0, 0);
    h1 {
      // display: inline-block;
      font-size: 18px;
      color: #7599bd;
      margin: 0;
      margin-left: 20px;
      margin-right: auto;

    }
    a {
      // display: block;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 40px;
      height: 40px;
      width: 40px;
      text-align: center;
      margin-left: auto;
      margin-right: 10px;
    }
  }
  .new-year {
    margin-top: 40px;
    height: 50px; 
    h2 {
      font-size: 15px;
      padding: 0px 10px;
    }
  }
}
#body {
  height: 100%;
  margin-top: 50px;
  // background-color: #f7f7f7;
}
#footer {
  min-height: 100px;
  box-sizing: border-box;
  background-color: #34495E;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;;
  align-items: center;
  padding: 30px;
  .links {
    display: flex;
    flex-direction: row;
    margin: 0px 0px 10px 0px;
    a {
      color:white;
      text-decoration: none;
      font-weight: bold;

      height: 40px;
      line-height: 40px;
      font-size: 18px;
      border-radius: 18px;
      transition: all 0.3s ease;
      margin: 0px 10px;
      &:hover {
        opacity: 0.6
      }
    }
  }
  p {
    font-size: 20px;
    margin: 10px 0px;
    &.bold {
      font-weight: bold;
    }
  }

  @media (max-width: 500px) {
    .links {
      flex-direction: column;
    }
  }
}

</style>
